import React, { ReactNode, Suspense } from 'react';
import { observer } from 'mobx-react';
import { init } from '~/stores/root-cx-store.factory';
import { RootStoreProvider } from '~/stores/root-cx-store.provider';
import Skeleton, { SkeletonProps } from 'react-loading-skeleton';
import { angularBootstrapStore } from '~/stores/angular-bootstrap.store';
import { useLoadFingerprintFromAngularToCx } from '~/common/hooks/useLoadFingerprintFromAngular';
import { GlobalCXProvider } from '~/components/ClientExperience/providers/global-context/global-cx-context.provider';
import { init as initGlobalCXContext } from '~/components/ClientExperience/providers/global-context/global-cx-context.factory';
import { resizeObserverPolyfill } from '~/utils/dom.utils';
import { useCXStoreCredentials } from '~/common/reactLayer/useCXStoreCredentials';
import { useCXRootStore } from '~/components/ClientExperience/stores/cx-root-store.provider';

initGlobalCXContext();
init();
resizeObserverPolyfill();

interface Props {
    children: ReactNode | ReactNode[];
    loader?: SkeletonProps;
}

const ReactAppWrapper = observer(({ children, loader }: Props) => {
    const rootStore = useCXRootStore();

    const { user, company, config, mobilePreviewMode, isOnboardingPreview } =
        angularBootstrapStore;

    useCXStoreCredentials({
        store: rootStore,
        user,
        company,
        config,
        mobilePreviewMode,
        isOnboardingPreview
    });

    useLoadFingerprintFromAngularToCx();

    return (
        <Suspense fallback={!!loader ? <Skeleton {...loader} /> : <div />}>
            {children}
        </Suspense>
    );
});

export default function CXRootStoreLayer({ children, loader }: Props) {
    return (
        <GlobalCXProvider>
            <RootStoreProvider>
                <ReactAppWrapper loader={loader}>{children}</ReactAppWrapper>
            </RootStoreProvider>
        </GlobalCXProvider>
    );
}
